import { useEffect, useState } from 'react'
import { n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { SoundProvider } from '../../../common/audio/play/Audio'
import { TextRecordActivity, Word, judgeAnswer } from '../Common'

const SpeakActivity = ({
  content,
  done,
  setDone,
  nextActivity,
  addFail,
  retry,
  audio_url,
  textKo,
  idx,
  wordCount,
}: {
  content: Word[]
  done: boolean
  setDone: (done: boolean) => void
  nextActivity: () => void
  addFail: () => void
  retry?: boolean
  audio_url?: string
  textKo?: string
  idx?: any
  wordCount?: number
}) => {
  const { t, locale } = useTranslation()
  const [solved, setSolved] = useState<null | 'done' | 'retry-audio' | 'fail' | 'fail-audio'>(null)
  const [retryCnt, setRetryCnt] = useState(0)
  const [audio, setAudio] = useState<ArrayBuffer | null>(null)
  const words = content.map((word, index) => {
    return {
      word: word.word,
      correct: null,
      separator: word.separator,
      keyword: word.keyword,
      hidden: word.keyword,
      ns: word.ns,
    }
  })
  const [result, setResult] = useState(words)

  useEffect(() => {
    return () => {
      try {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopAudio' }))
      } catch (e) {
        console.log(e)
      }
    }
  }, [])

  const handleStopRecording = (text: string, audio: ArrayBuffer) => {
    setAudio(audio)
    const { result, totalCnt, correctCnt } = judgeAnswer(words, text)
    setResult(result)
    if (correctCnt > totalCnt * 0.5) setSolved('done')
    else {
      setRetryCnt(retryCnt + 1)
      if (retryCnt >= 2) {
        setSolved('fail-audio')
        addFail()
      } else {
        setSolved('retry-audio')
      }
    }
  }

  const handleSubmitText = (text: string) => {
    setAudio(null)
    const { result, correctCnt, totalCnt } = judgeAnswer(words, text)
    setResult(result)
    if (correctCnt > totalCnt * 0.5) setSolved('done')
    else {
      setRetryCnt(retryCnt + 1)
      if (retryCnt >= 2) {
        setSolved('fail-audio')
        addFail()
      } else {
        setSolved('retry-audio')
      }
    }
  }

  useEffect(() => {
    if (!solved) setResult(words)
  }, [solved])

  return (
    <SoundProvider key="speak-activity">
      <TextRecordActivity
        handleStopRecording={handleStopRecording}
        handleSubmitText={handleSubmitText}
        words={result}
        blind
        fixed
        title={t(n_ai_tutor.study_activity.two_title)}
        nextActivity={nextActivity}
        solved={solved}
        retryCnt={retryCnt}
        audio={audio}
        setSolved={setSolved}
        retry={retry}
        audio_url={audio_url}
        textKo={textKo}
        idx={idx}
        showKo={locale === 'ko'}
        wordCount={wordCount}
      />
    </SoundProvider>
  )
}

export default SpeakActivity
